import { computed, type MaybeRefOrGetter, onScopeDispose, ref, toValue, watch } from 'vue'

interface OverlayEntry {
  level: number
}

const openOverlays: OverlayEntry[] = []

export function useOverlayStack(isOpen: MaybeRefOrGetter<boolean>) {
  const entry: OverlayEntry = { level: 0 }
  const level = ref(0)

  const remove = () => {
    const index = openOverlays.indexOf(entry)
    if (index !== -1) openOverlays.splice(index, 1)
  }

  watch(() => toValue(isOpen), (open) => {
    remove()
    if (open) {
      entry.level = (openOverlays.at(-1)?.level ?? 0) + 1
      openOverlays.push(entry)
    }
    level.value = open ? entry.level : 0
  }, { immediate: true })

  onScopeDispose(remove)

  const isTop = () => openOverlays.at(-1) === entry

  const stackStyle = computed(() => ({ '--z-stack': String(level.value) }))

  return { isTop, level, stackStyle }
}
